import { lazy } from '@loadable/component';

const AccountView = lazy(() =>
  import(
    /* webpackChunkName: "account_view" */
    './account_view'
  )
);

export default AccountView;
